import { render, staticRenderFns } from "./HeaderReadingListeningResult.vue?vue&type=template&id=65e5c2f5&scoped=true"
import script from "./HeaderReadingListeningResult.vue?vue&type=script&lang=js"
export * from "./HeaderReadingListeningResult.vue?vue&type=script&lang=js"
import style0 from "./HeaderReadingListeningResult.vue?vue&type=style&index=0&id=65e5c2f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5c2f5",
  null
  
)

export default component.exports